// extracted by mini-css-extract-plugin
export var content = "styles-module--content--26c74";
export var filler = "styles-module--filler--12932";
export var report = "styles-module--report--9e625";